import { gql } from 'apollo-boost'

const RESOLVE_MENU_SCRAPING_TASK_BY_RECRAWL_DOCUMENT_MENU = gql`
  mutation resolveMenuScrapingTaskByRecrawlDocumentMenu($id: ID!) {
    resolveMenuScrapingTaskByRecrawlDocumentMenu(id: $id) {
      id
    }
  }
`

export default RESOLVE_MENU_SCRAPING_TASK_BY_RECRAWL_DOCUMENT_MENU
